import Promise from 'bluebird';
import { setDefaultMediaTypeSuccess } from './actions';



export const setDefaultMediaType = (data) => {
  
  const { mediaType } = data;
  const currentType = localStorage.defaultMediaType;
  
  if (mediaType && mediaType !== currentType) {
    localStorage.defaultMediaType = mediaType;
  }

  return setDefaultMediaTypeSuccess();
}



/** WEBPACK FOOTER **
 ** ./src/app/modules/router/tasks.js
 **/